/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minimalist_MontserratInputs */

const en_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalist (Montserrat)`)
};

const es_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalista (Montserrat)`)
};

const fr_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimaliste (Montserrat)`)
};

const de_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistisch (Montserrat)`)
};

const ja_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミニマリスト (Montserrat)`)
};

const zh_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`极简主义 (Montserrat)`)
};

const ar_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بسيط (Montserrat)`)
};

const id_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalis (Montserrat)`)
};

const it_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalista (Montserrat)`)
};

const ru_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минималистичный (Montserrat)`)
};

const pt_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalista (Montserrat)`)
};

const ko_minimalist_montserrat = /** @type {(inputs: Minimalist_MontserratInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미니멀리스트 (Montserrat)`)
};

/**
* | output |
* | --- |
* | "Minimalist (Montserrat)" |
*
* @param {Minimalist_MontserratInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const minimalist_montserrat = /** @type {((inputs?: Minimalist_MontserratInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minimalist_MontserratInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minimalist_montserrat(inputs)
	if (locale === "es") return es_minimalist_montserrat(inputs)
	if (locale === "fr") return fr_minimalist_montserrat(inputs)
	if (locale === "de") return de_minimalist_montserrat(inputs)
	if (locale === "ja") return ja_minimalist_montserrat(inputs)
	if (locale === "zh") return zh_minimalist_montserrat(inputs)
	if (locale === "ar") return ar_minimalist_montserrat(inputs)
	if (locale === "id") return id_minimalist_montserrat(inputs)
	if (locale === "it") return it_minimalist_montserrat(inputs)
	if (locale === "ru") return ru_minimalist_montserrat(inputs)
	if (locale === "pt") return pt_minimalist_montserrat(inputs)
	return ko_minimalist_montserrat(inputs)
});